import React from "react";
import { Link } from "react-router-dom";

import IncidentDate from "../../incidents/components/IncidentDate";

const PostList = ({ posts }) => {
  const containerStyles = {
    color: "#EBF1F5",
    width: "90%",
    background: "rgba(0, 0, 0, 0.85)",
    padding: "0 20px 20px",
    margin: 10,
    borderRadius: 5,
    boxShadow: "0px 10px 33px 0px rgba(0,0,0,0.75)",
  };

  if (posts.length === 0)
    return (
      <div style={containerStyles}>
        <h1 style={{ paddingTop: "15px", textAlign: "center" }}>Reports</h1>
        <div style={{ margin: "0 auto" }}>
          No reports matched the selected filters.
        </div>
      </div>
    );
  return (
    <div style={containerStyles}>
      <h1 style={{ paddingTop: "15px", textAlign: "center" }}>Reports</h1>
      <table style={{ margin: "0 auto" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left" }}>Subject</th>
            <th style={{ textAlign: "left" }}>Author</th>
            <th style={{ textAlign: "left" }}>Date</th>
          </tr>
        </thead>
        <tbody>
          {posts &&
            posts.map((post, i) => (
              <tr key={i}>
                <td>
                  <Link to={`/sitrep/${post.id}`}>{post.subject}</Link>
                </td>
                <td>
                  {post.author} - {post.esf}
                </td>
                <td>
                  <IncidentDate date={post.postedDate} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default PostList;
